export default "__VITE_ASSET__CHVTk_Du__"